import { Body1, Headline3 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import React from 'react'
import styled from 'styled-components'
import { ExpansionAnimationSlice } from 'interfaces/GeneratedLandingPage'
import ReviewsSection from './ReviewsSection'
import BackgroundAnimationWrapper from '../Homepage/BackgroundAnimationWrapper'
import ReviewCard from './ReviewCard'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import useMedia from 'lib/hooks/useMedia'

const Container = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px;
    background-color: ${theme.colors.flamingoPink};
    @media (max-width: 1050px) {
        height: auto;
        padding: 0;
    }
`

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
    padding: 20px;
    p,
    h3 {
        max-width: 70%;
        @media (max-width: 1050px) {
            max-width: 80%;
        }
    }
    .reviews {
        width: 90vw;
        overflow: visible;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 25px;
        padding: 25px 0px;
        .item-1,
        .item-5,
        .item-2,
        .item-6 {
            justify-self: center;
        }
        .item-3 {
            justify-self: start;
        }
        .item-4 {
            justify-self: end;
        }
        & > div {
            opacity: 0.7;
            &:hover {
                opacity: 1;
            }
        }
        @media (max-width: 1440px) {
            .item-1,
            .item-5 {
                justify-self: center;
                position: relative;
                right: 60px;
            }
            .item-2,
            .item-6 {
                justify-self: center;
                position: relative;
                left: 60px;
            }
        }
        @media (max-width: 1250px) {
            width: 90vw;
            padding: 25px 10px;
        }
        @media (max-width: 1050px) {
            * {
                display: none;
            }
            height: 500px;
        }
    }
    @media (max-width: 750px) {
        height: auto;
        width: 100%;
        .mobile-image {
            display: block;
        }
    }
    .mobile-reviews {
        width: 100%;
        display: grid;
        place-content: start;
        grid-template-columns: 1fr 1fr 1fr;
        overflow-x: auto;
    }
`

interface Props {
    items: {
        text: string
        user: string
    }[]
    primary: ExpansionAnimationSlice['primary']
}

const ExpansionAnimation = ({ items, primary }: Props) => {
    const lg = useMedia(deviceSize.lg)
    return (
        <Container>
            <ContentWrapper>
                <Headline3 color={theme.colors.white} textAlign="center" marginBottom={0}>
                    {primary.title}
                </Headline3>
                <Body1 color={theme.colors.white} textAlign="center" marginBottom={120}>
                    {primary.text}
                </Body1>
                <div className="reviews">
                    {items?.length
                        ? items.map(({ text, user }, i) => (
                              <ReviewCard
                                  key={`review-card-${i}`}
                                  text={text}
                                  user={user}
                                  isScrollable
                                  className={`item-${++i}`}
                              />
                          ))
                        : null}
                </div>
                <BackgroundAnimationWrapper
                    src="expansion/expansion_animation.json"
                    loop
                    autoPlay
                    rendererSettings={{
                        preserveAspectRatio: 'xMidYMid meet',
                    }}
                    placeholderSrc={primary.image_webp?.url}
                    width={293}
                    height={611}
                />
            </ContentWrapper>
            {lg ? <>{items?.length ? <ReviewsSection items={items} isScrollable /> : null}</> : null}
        </Container>
    )
}

export default ExpansionAnimation
